import "core-js/stable";
import "regenerator-runtime/runtime";
import ForthTheme from "./js/forth-theme.js";

import "./style/stylesheets/styles.scss";

const theme = new ForthTheme();
theme.init();
